module.exports = __webpack_public_path__ + "static/media/linkedin_round.e8bf97ad.svg";